module.exports = __webpack_public_path__ + "assets/cover-top-default-25d6c392.png";